import React, { useState } from "react";
import { FaMapMarkerAlt, FaStar, FaRupeeSign } from "react-icons/fa";
import { MdOutlineReviews } from "react-icons/md";
import { BiSolidDiscount } from "react-icons/bi";
import { MdRestaurant } from "react-icons/md";
import { BiSolidDrink } from "react-icons/bi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { FaDirections } from "react-icons/fa";
import "./PartywittyPay.css";
import { API_BASE_URL, openInGoogleMaps } from "../utils";
import PartywittyOffers from "../Club-aboutus/custom-comp/PartywittyOffers";
import logo from "../Assets/logo.svg";

import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const offers = [
  {
    id: 1,
    title: "Discover Your Rewards",
    desc: "Save Up to ₹200",
    btnText: "Watch Teaser",
  },
  {
    id: 2,
    title: "Upto 50% Off",
    desc: "On Food & Beverages Bill",
    btnText: "Pre-Booking",
  },
  {
    id: 3,
    title: "Flat 25% OFF",
    desc: "For Total bill",
    btnText: "Pay Bill",
  },
];


const url = `${API_BASE_URL}/master/assets/uploads/`;
const PartywittyPay = () => {
  const [price, setPrice] = useState(null);
  const [selected, setSelected] = useState("food");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");


  const [searchParams] = useSearchParams();
  const clubId = searchParams.get("club_id");
  const club_name = searchParams.get("club_name");
  const city = searchParams.get("city");
  const area = searchParams.get("area");
  const address = searchParams.get("address");
  const img = searchParams.get("img");

  console.log("club_id", clubId, "club_name", club_name, "city", city, "area", area, "address", address, "img", img);





  const handleAmountPass = async (amount) => {
    navigate(`/partywitty-pay/checkout`, { state: { amount, selected, club_id: clubId } });
  };


  return (
    <div className="partywitty-pay-container">


      <div className="partywitty-pay-top-bar">
        <button><HiOutlineArrowNarrowLeft onClick={() => navigate(-1)} />Back</button>

        <span className="partywitty-pay-com-logo"><img src={logo} alt="" /></span>

      </div>

      <div className="partywitty-pay-container-wrapper">
        {/* Header */}
        <div className="partywitty-pay-header">
          <div className="partywitty-pay-club-info">
            <h3><span className="partywitty-pay-logo">
              <img src={url + img} alt=""
              onError={
                (e) => {
                  e.target.onerror = null;
                  e.target.src = "https://images.unsplash.com/photo-1578736641330-3155e606cd40?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2x1YnxlbnwwfHwwfHx8MA%3D%3D";
                }
              }
              />
              </span> {club_name} <FaStar className="star" /> 4.1</h3>
            <span className="review"><MdOutlineReviews /> (03)</span>
          </div>
        </div>
        <div className='bid-new-card-text-section-location'>
          <p><span className='icon-size-set'><HiOutlineLocationMarker /></span></p>
          {address ? (address.length > 20 ? address.slice(0, 20) + "..." : address) : ""}
          <div className='bid-new-card-text-section-location-distance' onClick={() => openInGoogleMaps()}>
            <span><FaDirections /> {Math.round(10)} Kms</span>
          </div>
        </div>

        {/* Toggle */}
        <div className="partywitty-pay-price-input-wrapper">
          <h6>Split Bill & Apply Discounts</h6>
          <div className="partywitty-pay-toggle">
            <label className={`partywitty-pay-radio-option ${selected === "food" ? "partywitty-pay-radio-option-checked" : ""}`}>
              <input
                type="radio"
                name="billType"
                value="food"
                checked={selected === "food"}
                onChange={() => setSelected("food")}
              />
              <span>For F&B  <span className={` ${selected === "food" ? "partywitty-pay-discount-tag" : "partywitty-pay-discount-tag-unchecked"}`}>
                <MdRestaurant /> 25% OFF
              </span></span>
            </label>

            {/* <label className={`partywitty-pay-radio-option ${selected === "alcohol" ? "partywitty-pay-radio-option-checked" : ""}`}>
              <input
                type="radio"
                name="billType"
                value="alcohol"
                checked={selected === "alcohol"}
                onChange={() => setSelected("alcohol")}
              />
              <span>For Alcohol  <span className={` ${selected === "alcohol" ? "partywitty-pay-discount-tag" : "partywitty-pay-discount-tag-unchecked"}`}>
                <BiSolidDrink /> 40% OFF
              </span></span>
            </label> */}
          </div>
        </div>


        {/* Discount Tag */}


        {/* Price Input */}
        <div className="partywitty-pay-price-input-wrapper">
          <span className="partywitty-pay-price-input-label">Enter prices </span>
          <div className="partywitty-pay-input">
            <FaRupeeSign color="#7464E4" />
            <span className="partywitty-pay-input-divider"></span>
            <input
              type="number"
              placeholder="Enter Price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
        </div>
        <p className="partywitty-pay-note">
          Apply Discounts Separately For Food And Beverages Before Completing Your Payment
        </p>

        <div className="partywitty-offers-section-wrapper">
          <PartywittyOffers />
        </div>

        {/* Proceed Button */}
        <div className="partywitty-pay-footer">
          <button className={`partywitty-pay-proceed-btn ${loading || price <= 0 ? "disabled" : ""}`}
            disabled={loading || !price || price <= 0}
            onClick={() => handleAmountPass(price)}>
            Proceed to Pay</button>
        </div>
      </div>

    </div>
  );
};

export default PartywittyPay;
